<template>
	<div>
	   <el-row style="height:80px;position:fixed;top: 0;z-index:999;min-width:1200px;">
	     <el-col :span="18">
			 <div class="navlist">
				 <div style="display:flex;align-items: center;">
				    <img :src="logo" alt="" sizes="" srcset="" style="width:40px;height:40px;margin-right:10px;" />
				    <h2>
					   {{site_title}}
					</h2>
				 </div>
				   <router-link to="/serviceHome/serviceindex" active-class="active-link">首页</router-link>
				   <router-link to="/serviceHome/serviceOrder" active-class="active-link">我的订单</router-link>
				   <router-link to="/serviceHome/invitedList"  active-class="active-link">
					   <diV style="position:relative;">
						   被邀标<div class="dian" v-if="userinfo.invite_count"></div>
					   </diV>
				   </router-link>
				   <router-link to="/serviceHome/myQuote" active-class="active-link">我的报价</router-link>
				   <router-link to="/serviceHome/MyReview" active-class="active-link"><diV style="position:relative;">我的评审<div class="dian" v-if="userinfo.need_review_count"></div></diV></router-link>
				   <el-dropdown @command="handleDropdownCommand">
					   <div style="position:relative;">
						   <span class="nav-item" :class="{ 'active-link': isPersonalCenterActive }">个人中心<i class="el-icon-arrow-down el-icon--right"></i></span>
					   </div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="/serviceHome/MyWallet">
								<span :class="{ 'active-link': isPathActive('/serviceHome/MyWallet') }">我的钱包</span>
							</el-dropdown-item>
							<el-dropdown-item command="/serviceHome/ServicePromotion">
								<span :class="{ 'active-link': isPathActive('/serviceHome/ServicePromotion') }">我的推荐</span>
							</el-dropdown-item>
							<el-dropdown-item command="/serviceHome/UserInfo">
								<span :class="{ 'active-link': isPathActive('/serviceHome/UserInfo') }">个人信息</span>
							</el-dropdown-item>
							<el-dropdown-item command="/serviceHome/ServiceFeedback">
								<span :class="{ 'active-link': isPathActive('/serviceHome/ServiceFeedback') }">意见反馈</span>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
			 </div>  
		</el-col>
	    <el-col :span="2" style="display:flex;">
			<div class="disng">
				<div style="position:relative;">
					<img src="@/assets/lingdan.png" alt="" sizes="" srcset=""   class="disng1" @click="message"/>
					<span v-if="userinfo.unread_count>0" class="xiaoxi" style=""></span>
				</div>
			     <img :src="(userinfo && userinfo.avatar) || ''" alt="" sizes="" srcset=""   class="disng2" @click="getuser"/>
			</div>
		</el-col>
	   </el-row>
	   <div style="height:80px;"></div>
	   <router-view></router-view>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	import { BaseGetConfig} from '@/api/api'
	export default {
	  data() {
	    return {
			logo:"",
			site_title:""
		}
	   },
	   computed: {
	   		...mapState({
	   			userinfo: (state) => state.userInfo || {}
	   		}),
	   		isPersonalCenterActive() {
	   		  const p = this.$route && this.$route.path ? this.$route.path : ''
	   		  return /^\/serviceHome\/(MyWallet|UserInfo|ServicePromotion|ServiceFeedback)(\/|$)/.test(p)
	   		}
	   },
	   created() {
	   	 this.$store.dispatch('fetchPersonal')
	   	 this.getBaseGetConfig()
		 this.logo=localStorage.getItem("login")
		 this.site_title=localStorage.getItem("site_title")
	   },
	    methods: {
			getBaseGetConfig(){
				BaseGetConfig({
					key:"demand_file_config,demand_off_time"
				}).then(res=>{
					this.demand_file_config=res.data.demand_file_config
					this.demand_off_time=res.data.demand_off_time
				})
			},
			getpersonal(){
				return this.$store.dispatch('fetchPersonal')
			},
			message(){
				if (this.$route.path !== '/serviceHome/messagelist') {
				    this.$router.push('/serviceHome/messagelist')
				}
			},
			getuser(){
				if (this.$route.path !== '/serviceHome/UserInfo') {
				    this.$router.push('/serviceHome/UserInfo')
				}
		 },
		 handleDropdownCommand(command) {
			if (command && this.$route.path !== command) {
				this.$router.push(command)
			}
		 },
		 isPathActive(path) {
			if (!path) return false
			// 兼容路径后缀（例如 query/hash）
			return this.$route && this.$route.path ? this.$route.path === path : false
			}
		}
	}
</script>

<style scoped>
	.el-row {
		width:100%;
		background-color:#fff;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.xiaoxi{
		position:absolute;
		right:0;top:0px;
		width:10px;
		height:10px;
		display: block;
		background-color: #FF0000;
		border-radius:50%;
	}
	.active-link{
		color:#1E3A8A ;
	}
	.navlist{
		display:flex;
		align-items: center;
	}
	.navlist a{
		font-weight: bold;
		font-size: 20px;
		margin-left:72px;
		color:#999999;
	}
	.nav-item {
	  font-weight: bold;
	  font-size: 20px;
	  margin-left: 72px;
	  cursor: pointer;
	  display: inline-flex;
	  align-items: center;
	}
	
	.nav-item .el-icon-arrow-down {
	  font-size: 14px;
	  margin-left: 4px;
	}
	/* 下拉项使用 @click 跳转后，不再依赖 router-link 的铺满样式 */
	::v-deep .el-dropdown{
		color:#999999;
	}
	::v-deep .active-link{
	    color: #1E3A8A !important;
	}
	.disng{
		display:flex;
		align-items: center;
	}
	.disng1{
		width:24px;
		height:24px;
		margin-left:24px;
		cursor:pointer;
	}
	.disng2{
		width:32px;
		height:32px;
		border-radius:50%;
		margin-left:24px;
		cursor:pointer;
	}
	.dian{
		width:10px;
		height:10px;
		border-radius:50%;
		background-color: #FF0000;
		position:absolute;
		top: 2px;
		right: -3px;
	}
</style>